import { render, staticRenderFns } from "./layoutModalFooter.vue?vue&type=template&id=13c7d4a7&"
import script from "./layoutModalFooter.vue?vue&type=script&lang=js&"
export * from "./layoutModalFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports